import React, { Component } from "react";
import {  Modal } from "react-bootstrap";
import AddressList from "containers/property/AddressList";



export default class AddressModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
         
            isLoading: true,
            
        };

        
     
       
    }
    

    async componentDidMount() {
        console.log("In AddressModal componentDidMount");
        if (!this.props.isAuthenticated) { // if false
            return;
        }

        if (!this.props.show) {
            return null;
        }

           
    }

    componentWillUnmount() {
        this.setState({ entities: [] });
    }


    

    renderAddresses() {
        return (
            
            <Modal
                show={this.props.show}
                onHide={this.props.toggleAddressModal}
                dialogClassName="modal-90w"
                >
                <Modal.Header closeButton>
                    <Modal.Title>Addresses</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ 'overflowX': 'scroll' }}>
           
               
                

              

                        <AddressList
                        filter={this.props.filter}
                        isAuthenticated={this.props.isAuthenticated}
                        isLoading={this.state.isLoading}
                        controlType="table"
                        saveForm={this.props.saveForm}
                        user={this.props.user}
                        data={this.props.data}
                        updateTableState={this.props.updateTableState}
                        saveRecord={this.props.saveRecord}
                        deleteRecord={this.props.deleteRecord}
                        validateRelatedRecord={this.props.validateRelatedRecord}
                        streetOptions={this.props.streetOptions}
                        />

                  
          
                    </Modal.Body>
            </Modal>
        );
    }
    
    


    render() {
        return (

            <div className="AddressEdit">
                {this.props.isAuthenticated ? this.renderAddresses() : console.log("error)")}
            </div>
        );
    }
}
